import _, { get } from "lodash";
import moment from "moment";

const Utils = {
  dateTime: (dt) => moment(dt).format("DD-MM-YYYY HH:mm"),

  apiUrl: (path) => process.env.REACT_APP_API_URL + "/" + path,

  apiHeaders: (extraparams = null) => {
    let headers = {
      headers: {
        "x-api-key": process.env.REACT_APP_X_API_KEY,
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "PUT,GET,POST,DELETE,OPTIONS,PATCH",
        "Access-Control-Allow-Headers":
          "Origin, Content-Type, X-Auth-Token, token, access-control-allow-origin",
        Accept: "application/json, text/plain, */*",
      },
    };

    const uData = Utils.getUserData();
    if (uData && _.get(uData, "token", false)) {
      headers["headers"]["token"] = uData.token;
      headers["headers"]["hotel-id"] = uData.hotel_id || "";
    }

    if (extraparams) {
      headers = { ...headers, ...extraparams };
    }
    return headers;
  },

  isLoggedIn: () => {
    const dt = Utils.getUserData();
    return (
      dt !== false &&
      _.get(dt, "token", false) !== false &&
      (Utils.isHR() ||
        Utils.isAMT() ||
        Utils.isPhotographer() ||
        Utils.isHotelOwner())
    );
  },

  isHR: () => {
    const dt = Utils.getUserData();
    return dt !== false && _.get(dt, "isHR", false) === true;
  },

  isAMT: () => {
    const dt = Utils.getUserData();
    return dt !== false && _.get(dt, "isAMT", false) === true;
  },

  isPhotographer: () => {
    const dt = Utils.getUserData();
    return dt !== false && _.get(dt, "isPG", false) === true;
  },

  isHotelOwner: () => {
    const dt = Utils.getUserData();
    return dt !== false && _.get(dt, "isHO", false) === true;
  },

  hasArchiveAccess: () => {
    const dt = Utils.getUserData();
    return dt !== false && Number(_.get(dt, "archive_access", 0)) === 1;
  },

  getSelectedHotelId: () => {
    const dt = Utils.getUserData();
    return _.get(dt, "hotel_id", false);
  },

  panelTitle: () => {
    return Utils.isAMT()
      ? "Area Marketing Team"
      : Utils.isHR()
        ? "Hotel Photography Lead"
        : Utils.isPhotographer()
          ? "Photographer"
          : Utils.isHotelOwner()
            ? "Owner Representative"
            : "User";
  },

  userTypeName: (type) => {
    return (
      {
        AMT: "Area Marketing Team",
        HR: "Hotel Photography Lead",
        PG: "Photographer",
        HO: "Owner Representative",
        BT: "Brand Team",
      }[type] || "User"
    );
  },

  getSetColors: (setNum = false) => {
    const setColors = [
      "",
      "bg-red-200 hover:bg-red-300",
      "bg-green-200 hover:bg-green-300",
      "bg-blue-200 hover:bg-blue-300",
      "bg-yellow-200 hover:bg-yellow-300",
      "bg-gray-200 hover:bg-gray-300",
    ];
    if (setNum === false) return setColors;
    return setColors[setNum] || "";
  },

  getPhotoshootTypes: () => {
    return {
      GEN: "Lifestyle/Architectural Images",
      REN: "Renderings",
      LA: "Legacy Assets",
    };
  },

  getPhotoshootTypeName: (type) => {
    let photoshootTypes = {
      ...Utils.getPhotoshootTypes(),
      LIF: "Lifestyle Images",
      ARC: "Architectural Images",
      PPI: "Post Production Images",
    };
    return photoshootTypes[type] || type;
  },

  getPhotoshootHotelTypes: () => {
    return {
      new: "Pre-opening/New Build",
      established: "External Conversion",
      converted: "Internal Conversion",
      refresh: "Renovation/Refresh/Update",
    };
  },

  getPhotoshootHotelTypeName: (type) => {
    return Utils.getPhotoshootHotelTypes()[type] || type;
  },

  hasBrand: () => {
    const dt = Utils.getUserData();
    return (
      dt !== false &&
      _.get(dt, "hotel_id", false) !== false &&
      _.get(dt, "hotel_id", false) !== null
    );
  },

  removeSession: () => {
    let dt = Utils.getUserData();
    // console.log(dt, "session data")
    dt.token = false;
    // const backup = localStorage.getItem(process.env.REACT_APP_APPNAME + '-userData');
    localStorage.setItem(
      process.env.REACT_APP_APPNAME + "-userData",
      JSON.stringify(dt),
    );
  },

  getUserData: () => {
    let userData = localStorage.getItem(
      process.env.REACT_APP_APPNAME + "-userData",
    );
    if (userData) {
      return JSON.parse(userData);
    } else {
      return false;
    }
  },

  setUserData: (data) => {
    const uData = _.get(data, "userData", false);
    // return;
    if (uData === false) {
      //=== logout
      localStorage.removeItem(process.env.REACT_APP_APPNAME + "-userData");
    } else {
      if (uData.token) {
        localStorage.removeItem(process.env.REACT_APP_APPNAME + "-userData");
      }

      let userData = Utils.getUserData();
      if (!userData) {
        userData = {};
      }
      uData["token"] = _.get(data, "token", false);
      uData[`stepData${userData.id}`] = userData[`stepData${userData.id}`];
      userData = { ...userData, ...uData };
      localStorage.setItem(
        process.env.REACT_APP_APPNAME + "-userData",
        JSON.stringify(userData),
      );
    }
  },

  saveUserData: (data, stepData) => {
    if (_.get(data, "token", false)) {
      data[`stepData${data.id}`] = stepData;
      localStorage.setItem(
        process.env.REACT_APP_APPNAME + "-userData",
        JSON.stringify(data),
      );
    }
  },

  addToUserData: (data) => {
    let userData = Utils.getUserData();
    if (!userData) {
      userData = {};
    }
    userData = { ...userData, ...data };
    localStorage.setItem(
      process.env.REACT_APP_APPNAME + "-userData",
      JSON.stringify(userData),
    );
  },

  removeFromUserData: (key) => {
    let userData = Utils.getUserData();
    if (!userData) {
      return;
    }
    delete userData[key];
    localStorage.setItem(
      process.env.REACT_APP_APPNAME + "-userData",
      JSON.stringify(userData),
    );
  },

  clearSelectedHotel: () => {
    const userData = Utils.getUserData();
    if (!userData) {
      return;
    }

    const nextUserData = { ...userData };
    delete nextUserData.hotel_id;
    delete nextUserData.hotel_name;

    localStorage.setItem(
      process.env.REACT_APP_APPNAME + "-userData",
      JSON.stringify(nextUserData),
    );
  },

  canAccess: (module) => {
    const udata = Utils.getUserData();
    if (udata.role_id === parseInt(process.env.REACT_APP_SUPERADMIN_ROLE)) {
      return true;
    }
    return _.get(udata, "rbac", []).includes(module);
  },

  showPagination: (pageInfo, gotoPage) => {
    const curpage = Math.ceil(pageInfo.start / pageInfo.limit) + 1;
    const totpage = Math.ceil(pageInfo.total / pageInfo.limit);

    return (
      <div className="flex justify-between items-center mt-4">
        <span className="text-sm text-gray-600">
          Showing {pageInfo.start + 1} to{" "}
          {_.min([pageInfo.start + pageInfo.limit, pageInfo.total])} of{" "}
          {pageInfo?.total || 0} Records
        </span>

        <div className="flex space-x-2">
          {curpage > 1 && (
            <button
              disabled={curpage === 1}
              onClick={gotoPage(curpage - 1)}
              className="px-3 py-1 border rounded disabled:opacity-50"
            >
              Prev
            </button>
          )}

          {new Array(totpage).fill(0).map((v, p) => (
            <button
              key={p}
              onClick={gotoPage(p + 1)}
              className={`px-3 py-1 border rounded ${curpage === p + 1 ? "bg-blue-600 text-white" : ""}`}
            >
              {p + 1}
            </button>
          ))}
          <button
            disabled={curpage === totpage}
            onClick={gotoPage(curpage + 1)}
            className="px-3 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      </div>
    );
  },

  todoBell: (type, idx = 0) => {
    //== index, text, color (0=>green, 1=>red)
    if (type == "HR" || type == "AMT") {
      return (
        [
          [0, "Photoshoot Form Submitted, to be verified by Photographer", 0],
          [1, "Upload Shot list", 1],
          [2, "Upload Styling Deck", 1],
          [3, "Styling Deck to be reviewed by Brand Team", 0],
          [4, "Download Styling Deck", 1],
          [5, "Upload Recce Deck", 1],
          [6, "Recce to be reviewed by Brand Team", 0],
          [7, "Download Recce Deck", 1],
          [8, "Post production images to be uploaded", 1],
          [9, "Post production images to be uploaded by Photographer", 0],
          [10, "Post Production images under review by Brand Team", 0],
          [11, "Final documents to be submitted by Photographer", 0],
          [12, "LOC to be issued by Brand Team", 0],
          [13, "Download Final Images and Documents", 1],
          [14, "Recce feedback received from Brand Team", 1],
        ][idx] || [0, false, 0]
      );
    } else if (type == "PG" || type == "HO") {
      return (
        [
          [0, "Photoshoot Form Submitted, to be verified by Photographer", 1],
          [1, "Shot list to be uploaded", 0],
          [2, "Upload Styling Deck", 1],
          [3, "Styling Deck to be reviewed by Brand Team", 0],
          [4, "Download Styling Deck", 1],
          [5, "Upload Recce Deck", 1],
          [6, "Recce to be reviewed by Brand Team", 0],
          [7, "Post Production images to be uploaded", 1],
          [8, "Brand Team to review images", 0],
          [9, "Upload edits requested by Brand Team", 1],
          [10, "Brand Team to review images", 0],
          [11, "Submit Final Document", 1],
          [12, "LOC to be issued by Brand Team", 0],
          [13, "LOC issued by Brand Team", 0],
          [14, "Recce feedback received from Brand Team", 1],
        ][idx] || [0, false, 0]
      );
    } else {
      return [0, false, 0];
    }
  },
};

export default Utils;
